module.exports = __webpack_public_path__ + "img/resource-tech-image-53.efe1072b.jpg";